function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { IntlHelmet, LanguageProvider, OfflineOverlay } from 'modules/App';
import MobileAppLoader from 'components/MobileAppLoader';
import messages from '../../messages';
import styles from './MobileLoaderLayout.pcss';
var _React_Component;
class MobileLoaderLayout extends (_React_Component = React.Component) {
    render() {
        const titleMessage = this.props.metaTitleMessage ? this.props.metaTitleMessage : _object_spread({}, messages.meta.title);
        const descriptionMessage = this.props.metaDescriptionMessage ? this.props.metaDescriptionMessage : _object_spread({}, messages.meta.description);
        return /*#__PURE__*/ _jsx(LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.root,
                children: [
                    /*#__PURE__*/ _jsx(IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.root__container,
                        children: /*#__PURE__*/ _jsx(MobileAppLoader, {})
                    }),
                    /*#__PURE__*/ _jsx(OfflineOverlay, {})
                ]
            })
        });
    }
}
_define_property(MobileLoaderLayout, "propTypes", {
    // Explicit props
    metaTitleMessage: PropTypes.object,
    metaDescriptionMessage: PropTypes.object
});
export default withStyles(styles)(MobileLoaderLayout);
